import React from 'react'
import { IonLabel, IonSegment, IonSegmentButton } from '@ionic/react'
import './SegmentButtons.component.css'

export interface ISegmentButton {
  name: string
  id: number
  disabled?: boolean
  badge?: boolean
}

export interface ISegmentButtons {
  dataTestId: string
  segmentsList: ISegmentButton[]
  selected?: ISegmentButton
  disabled?: boolean
  className?: string
  onChangeAction: (option: ISegmentButton) => void
}

const SegmentButtons: React.FC<ISegmentButtons> = (props: ISegmentButtons) => {
  const { dataTestId, segmentsList, selected, disabled = false, className = '', onChangeAction } = props

  const onSegmentChange = (e: CustomEvent) => {
    const segment = segmentsList.find((seg) => seg.name === e.detail.value)
    if (segment && !segment.disabled) {
      onChangeAction(segment)
    }
  }

  return (
    <IonSegment
      data-testid={dataTestId}
      value={selected?.name}
      className={`${disabled ? 'segments-disabled' : ''} segment-buttons-container  ${className}`}
      onIonChange={onSegmentChange}>
      {segmentsList.map((data) => (
        <IonSegmentButton
          value={data.name}
          data-testid={data.id + data.name}
          key={data.id}
          disabled={data.disabled}
          className={`${data.name === selected?.name ? 'selected-segment' : ''}`}>
          <div className='segment-button-label-wrapper'>
            <IonLabel>{data.name}</IonLabel>
            {data.badge && <span className='segment-notification-dot' />}
          </div>
        </IonSegmentButton>
      ))}
    </IonSegment>
  )
}

export default SegmentButtons
